import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Dropdown/sgds-dropdown-item";
import { register } from "../../utils/ce-registry";

register("sgds-dropdown-item", Component);

export default createComponent({
  react: React,
  tagName: "sgds-dropdown-item",
  elementClass: Component,
  events: {}
});
